import {
  SELECT_QUESTION_OPTION,
  SUBMIT_QUESTION_ANSWER,
  DDQ_SUBMIT_ANSWER,
  DNDQ_SUBMIT_ANSWER,
  GROUPED_DNDQ_SUBMIT_ANSWER,
  MSCQ_SUBMIT_ANSWER,
} from '../Redux.constants';
import {COMPONENT_TYPE} from '@learningblocks/exp-constants/lib/Utilities';

export const selectQuestionOption = (option) => ({
  type: SELECT_QUESTION_OPTION,
  payload: option,
});

export const submitQuestionAnswer = (componentID, type) => ({
  type: getSubmitAnswerType(type),
  payload: {componentID},
});

function getSubmitAnswerType(type) {
  if (type === COMPONENT_TYPE.CSCQ || type === COMPONENT_TYPE.CSCQ_COLOR) {
    return SUBMIT_QUESTION_ANSWER;
  } else if (type === COMPONENT_TYPE.DDQ) {
    return DDQ_SUBMIT_ANSWER;
  } else if (type === COMPONENT_TYPE.DNDQ_COLOR) {
    return DNDQ_SUBMIT_ANSWER;
  } else if (type === COMPONENT_TYPE.GROUPED_DNDQ) {
    return GROUPED_DNDQ_SUBMIT_ANSWER;
  } else if (type === COMPONENT_TYPE.MSCQ) {
    return MSCQ_SUBMIT_ANSWER;
  } else {
    return null;
  }
}
